import { Injectable } from "@angular/core";
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpResponse } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { NotifyService } from "@app/core/services/notify.service";
import { AppInjector } from "@app/core/functions/app-injector";

/**
 * Process any notifications returned from the server
 */
@Injectable({
  providedIn: "root"
})
export class NotifyInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          try {
            if (event.body.notifications.length > 0) {
              this.notifyService.popNotifications(event.body.notifications);
            }
          } catch {}
        }
      })
    );
  }

  /**
   * Inject notification service at runtime
   */
  private get notifyService(): NotifyService {
    return AppInjector.get(NotifyService);
  }
}
